<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>
          <span class="glyphicon glyphicon-envelope"></span>
          <span class="glyphicon glyphicon-time"></span>
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <!-- <img src="@/assets/img/xhlogo.png"> -->
        <img :src="items.data.logoTop" />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.language)"
        >
          <router-link
            :to="{ path: item.path, query: { id: item.id } }"
            :data-i18n="item.language"
          >
            {{ item.name }}
            <span
              v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img
          class="center-block"
          src="@/assets/img/logo_black.png"
          alt="logo"
        />
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.language)"
          >
            <router-link
              :to="{ path: item.path }"
              :data-i18n="item.language"
            >
              {{ item.name }}
              <span
                v-if="item.children.length > 0"
                class="glyphicon glyphicon-menu-down"
              ></span>
              <i class="underline"></i>
            </router-link>
            <dl v-if="item.children.length > 0">
              <dt v-for="(i, n) in item.children" :key="n">
                <router-link :to="i.path">{{ i.name }}</router-link>
              </dt>
            </dl>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { translatePage } from '../assets/js/languages/change_language'
import languages from '../assets/js/languages/languages.js'
import { websiteUrl, fileUrl } from "../../url.js"; //全局配置URL ip 图片
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: languages.en.home_home,
      menuClass: "glyphicon glyphicon-menu-down",
      items: {},
      navList: [
        {
          name: "首页",
          path: "/home",
          language: "home_home",
          children: [],
        },
        {
          name: "智能化解决方案",
          path: "/service",
          language: "home_service",
          children: [],
        },
        {
          name: "产品中心",
          path: "/product/center",
          // id: "1932996173371469826",
          language: "home_product",
          children: [

          ],
        },

        {
          name: "成功案例",
          path: "/product/success",
          language: "home_success",
          // id: "1937700611953401857",
          children: [],
        },
        // {
        //   name: "技术支持",
        //   path: "/contactus",
        //   language: "home_technology",
        //   id: "",
        //   children: []
        // },
        {
          name: "新闻中心",
          path: "/newsinformation",
          language: "home_news",
          children: [],
        },
        {
          name: "关于我们",
          path: "/companyintroduction",
          language: "home_about",
          children: [],
        },
      ],
    };
  },
  mounted() {
    this.getHeader(); // 进入页面时自动获取数据
    this.updateNavIndex(this.$route);
    translatePage();
  },
  watch: {
    // 监听路由变化
    '$route'(to, from) {
      this.updateNavIndex(to);
      console.log('路由变化')
      this.$nextTick(() => {
        translatePage();
      })
    },
  },
  methods: {
    // 更新导航选中状态
    updateNavIndex(route) {
      const { query } = route;
      // nginx 会给预渲染目录补末尾斜杠（/service/），比较前先去掉
      const path = route.path.length > 1 ? route.path.replace(/\/+$/, "") : route.path;
      const foundIndex = this.navList.findIndex((item) => {
        // 基础路径匹配
        if (item.path !== path) return false;

        // 如果是 /product 路径，进一步检查 query.id
        if (path === "/product") {
          const targetId =
            item.name === "产品中心"
              ? "1932996173371469826"
              : item.name === "成功案例"
              ? "1937700611953401857"
              : null;
          return query.id === targetId;
        }

        // 其他路径直接匹配
        return true;
      });

      // 如果没有匹配到，默认选中第一个（如首页）
      if (foundIndex  !== -1) {
        this.navIndex = foundIndex;
        sessionStorage.setItem("navIndex", foundIndex);
      }
    },
    navClick(index, language) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = languages.en[language] || language;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    //获取数据信息
    async getHeader() {
      console.log(fileUrl);
      const cache = localStorage.getItem("headerData");
      if (cache) {
        this.items = JSON.parse(cache);
      }
      try {
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/homepage/getInfo/1`
        );
        response.data.data.logoTop = fileUrl + response.data.data.logoTop;
        this.items = response.data;
        console.log(this.items);
        localStorage.setItem("headerData", JSON.stringify(this.items));
        console.log(this.items, "header");
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
  },
};
</script>
<style scoped>
/* 顶部 */
#header {
  position: fixed;
  width: 100%;
  top: 0;
  background: #fff;
  transition: all ease 0.6s;
  z-index: 99999;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.08);
  display: block;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 60px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 157.5px;
  height: 46.2px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 60px;
  float: right;
  margin: 0;
  max-width: 900px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 18px;
  //font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #003987;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #003987;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #003987;
  text-decoration: none;
  border-bottom: 4px solid #003987;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}

/* ========== 平板端适配（768px - 991px） ========== */
@media screen and (min-width: 768px) and (max-width: 991px) {
  /* 调整PC导航在平板上的显示 */
  #header .header-nav {
    height: 70px;
    padding: 0 15px;
  }

  #header .header-nav .header-nav-logo {
    width: 90px;
  }

  #header .header-nav .header-nav-logo img {
    width: 120px;
    height: auto;
  }

  #header .header-nav .header-nav-wrapper {
    line-height: 70px;
  }

  #header .header-nav .header-nav-wrapper > li {
    margin: 0 12px;
  }

  #header .header-nav .header-nav-wrapper > li > a {
    font-size: 16px;
  }

  #header .header-nav .header-nav-wrapper > li > dl {
    width: 160px;
  }

  #header .header-nav .header-nav-wrapper > li > dl > dt {
    padding: 8px 12px;
  }
}

/* ========== 手机端适配（<768px） ========== */
@media screen and (max-width: 767px) {
  /* 隐藏原有的手机导航样式，使用新的手机适配 */
  #header .header-nav-m {
    position: relative;
    display: block;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 60px;
    position: relative;
    background: #fff;
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05);
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: auto;
    height: auto;
    max-width: 120px;
    max-height: 40px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏 菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 48px;
    font-size: 16px;
    line-height: 48px;
    background: #003987;
    position: relative;
    cursor: pointer;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 15px;
    margin-top: -12px;
    width: 24px;
    height: 24px;
    color: #fff;
    z-index: 999999;
    font-size: 14px;
    text-align: center;
    line-height: 24px;
  }

  /* 导航栏菜单容器 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 48px;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9999999;
    max-height: calc(100vh - 108px);
    overflow-y: auto;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: auto;
    line-height: normal;
    border-bottom: 1px solid #f0f0f0;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #333;
    font-size: 15px;
    font-weight: 500;
    padding: 14px 20px;
    position: relative;
    display: block;
    text-decoration: none;
    transition: all 0.3s ease;
  }

  /* 激活状态样式 */
  #header .header-nav-m .header-nav-m-wrapper > li.active > a {
    color: #003987;
    background: #f0f5ff;
  }

  /* 悬停效果 */
  #header .header-nav-m .header-nav-m-wrapper > li > a:hover {
    color: #003987;
    background: #f9f9f9;
  }

  /* 隐藏下划线（手机端不需要） */
  #header .header-nav-m .header-nav-m-wrapper > li > a i.underline {
    display: none;
  }

  /* 调整原手机导航的原有样式覆盖 */
  #header .header-nav-m .header-nav-m-wrapper {
    background: #fff;
  }

  #header .header-nav-m .header-nav-m-wrapper > li {
    height: auto;
  }

  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #333;
    font-weight: 500;
  }
}

/* ========== 小屏手机优化（<480px） ========== */
@media screen and (max-width: 480px) {
  #header .header-nav-m .header-nav-m-logo {
    height: 50px;
  }

  #header .header-nav-m .header-nav-m-logo img {
    max-width: 100px;
    max-height: 35px;
  }

  #header .header-nav-m .header-nav-m-menu {
    height: 44px;
    line-height: 44px;
    font-size: 14px;
  }

  #header .header-nav-m .header-nav-m-menu-wrapper {
    width: 22px;
    height: 22px;
    font-size: 12px;
    line-height: 22px;
    margin-top: -11px;
    right: 12px;
  }

  #header .header-nav-m .header-nav-m-wrapper {
    top: 44px;
    max-height: calc(100vh - 94px);
  }

  #header .header-nav-m .header-nav-m-wrapper > li > a {
    padding: 12px 16px;
    font-size: 14px;
  }
}

/* 保留原有的手机端样式，但覆盖优化 */
@media screen and (max-width: 997px) {
  /* 覆盖原有的样式，使用新的优化样式 */
  #header .header-nav-m .header-nav-m-logo {
    height: 60px;
  }

  #header .header-nav-m .header-nav-m-logo img {
    width: auto;
    height: auto;
  }

  #header .header-nav-m .header-nav-m-menu {
    background: #003987;
  }

  #header .header-nav-m .header-nav-m-wrapper {
    background: #fff;
  }

  #header .header-nav-m .header-nav-m-wrapper > li {
    height: auto;
  }

  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #333;
    font-weight: 500;
  }

  #header .header-nav-m .header-nav-m-wrapper > li > a i.underline {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue